module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external "mobx-state-tree"
// module id = 3
// module chunks = 0 1